module.exports = __webpack_public_path__ + "static/media/ios-locate.e4e11721.svg";